import React, { useState, useEffect, useContext } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  Button,
  Box,
  ModalHeader,
  ModalFooter,
  useBreakpointValue,
  Spinner,
  Table,
  Th,
  Thead,
  Tr,
  Tbody,
  Td,
  Center,
  Flex,
  Text,
} from "@chakra-ui/react";
import { appRequest } from "routes";
import FileViewer from "components/common/FileViewerPdfAndImage/FileViewer";
import { AppContext } from "AppProvider/AppContext";
import { combineValues } from "../function";
import CommentDrawer from "../CommentDrawer/CommentDrawer";
import RichTextEditor from "App/WorkFlow/component/AddWord/RichTextEditor";
import CustomInput from "components/common/customInput/CustomInput";

type ModalProps = {
  isOpen: boolean;
  onClose: () => void;
  file: any;
  values?: any;
  showValues?: boolean;
  level?: any;
  id?: any;
  getData?: any;
  commentData?: string;
  // handleGetPurchaseOrder: any;
  // setIsItemsOpen: any;
  isManual: boolean;
  isDisabled?: boolean;
  documentId?: any;
  type?: string;
  tagType?: string;
  documentType?: any;
  name?: string;
  selectedRows: any[];
  setSelectedRows: React.Dispatch<React.SetStateAction<any[]>>;
  commentModel: {
    selectedStatus: string;
    open: boolean;
    comment: string;
  };
  setCommentModel: React.Dispatch<
    React.SetStateAction<{
      selectedStatus: string;
      open: boolean;
      comment: string;
      isMulti?: boolean;
    }>
  >;
  handleGet: () => void;
  statusType: any;
};

export default function WordDocumentViewer({
  isOpen,
  onClose,
  file,
  values,
  showValues,
  type,
  id,
  level,
  getData,
  isManual,
  commentData,
  isDisabled = false,
  documentId,
  tagType,
  documentType,
  name,
  selectedRows,
  setSelectedRows,
  commentModel,
  setCommentModel,
  handleGet,
  statusType,
}: ModalProps): JSX.Element {
  const { toastNotify, accountDetails, workFlowData } = useContext(AppContext);
  const [isloading, setIsLoading] = useState(false);
  const [editorHtml, setEditorHtml] = useState({});
  const [title, setTitle] = useState("");
  const [editedValues, setEditedValues] = useState<any>({});
  const [fetchFileLoader, setFetchFileLoader] = useState(false);
  const [isCommentOpen, setIsCommentOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  // const [comment, setComment] = useState(commentData!=="-" ? commentData : '');
  const [comment, setComment] = useState("");

  let displayTables = {};

  function getLastValidateObject(arr: any) {
    for (let i = arr.length - 1; i >= 0; i--) {
      if (arr[i] !== null && arr[i] !== undefined) {
        return arr[i];
      }
    }
    return {};
  }

  useEffect(() => {
    let displayValues: any = {};
    if (!Array.isArray(values)) {
      displayValues = values?.values;
      setEditorHtml(displayValues?.content);
      setTitle(displayValues?.title);
    } else {
      if (Array.isArray(values) && values?.length) {
        const lastObject = getLastValidateObject(values);
        displayValues = lastObject.values || {};
      }
      setEditorHtml(displayValues?.content);
      setTitle(displayValues?.title);
    }
  }, [values]);

  const [sample, setSample] = useState({
    url: "",
    file: null,
    type: null,
    buffer: null,
  });

  useEffect(() => {
    if (isOpen) {
      getFile();
    }
  }, [isOpen]);

  const handleInvOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleInvCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleCloseCommentModal = () => {
    setIsCommentOpen(false);
  };

  const handleOpenCommentModal = () => {
    setIsCommentOpen(true);
  };

  const isCommentValid = () => {
    return comment.trim() !== "";
  };

  const handleValueChange = (key: string, value: string) => {
    setEditedValues((values: any) => ({
      ...values,
      [key]: value,
    }));
  };

  const getFile = async () => {
    try {
      if (file?._id) {
        setFetchFileLoader(true);
        const response: any = await appRequest("filesystem", "get", {
          id: file._id,
        });
        if (response) {
          if (response?.error) {
          } else {
            let buffer =
              typeof response === "string" ? JSON.parse(response) : response;
            buffer = new Uint8Array(buffer);

            const fileURL = URL.createObjectURL(
              new Blob([buffer], { type: file.metadata.contentType })
            );
            setSample({
              url: fileURL,
              file: file,
              type: file.metadata.contentType,
              buffer: buffer,
            });
          }
        }
      }
    } catch (error: any) {
      toastNotify({
        title: "Error",
        message: error.message,
        type: "error",
      });
    } finally {
      setFetchFileLoader(false);
    }
  };

  const viewerWidth = useBreakpointValue({ lg: true });

  let width =
    values && showValues && Object.entries(values)?.length > 0
      ? "90vw"
      : "45vw";

  const handleModalWheel = (event: React.WheelEvent<HTMLDivElement>) => {
    event.stopPropagation();
  };

  // updation of document status and comment
  const handleDocUpdate = async (
    status: string,
    level?: any,
    documentId?: any
  ) => {
    try {
      setIsLoading(true);
      let valus = combineValues(values, editedValues);

      const updatedStatus: any = {};
      updatedStatus["id"] = id;
      updatedStatus["level"] = level;
      updatedStatus["status"] = status;
      updatedStatus["comment"] = comment;
      updatedStatus["values"] = valus;
      updatedStatus["type"] = "document";
      const response: any = await appRequest(
        "document",
        "update",
        updatedStatus
      );

      if (response.status === "success") {
        toastNotify({
          title: "Updates submitted",
          message: "Updated successfully.",
        });
        setComment("");
        getData();
        onClose();
      } else {
        toastNotify({
          title: "Error",
          message: "Failed to update document.",
          type: "error",
        });
      }
      // console.log("done");
    } catch (error) {
      toastNotify({
        title: "Error",
        message: "Failed to update document.",
        type: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleSaveWord = async () => {
    try {
      setLoading(true);

      const values = {
        title: title,
        content: editorHtml,
      };
      const data = {
        values: values,
        type: "word",
        activeWorkflow: workFlowData._id,
      };
      if (values) {
        const response: any = await appRequest("document", "create", data);
        if (response.status === "success") {
          toastNotify({
            title: `Word Created successfully`,
            message: response.message || "Something went wrong.",
            type: "success",
          });
          onClose();
        } else {
          toastNotify({
            title: `Error getting the word.`,
            message: response.message || "Something went wrong.",
            type: "error",
          });
        }
      }
    } catch (err: any) {
      toastNotify({
        title: `Error getting the word.`,
        message: err.message || "Something went wrong.",
        type: "error",
      });
    } finally {
      handleGet();
      setLoading(false);
      setEditorHtml("");
      setTitle("");
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="full" isCentered>
      <ModalOverlay bg="rgba(0, 0, 0, 0.2)" />
      <ModalContent
        position="fixed"
        right={isOpen ? "0" : `-${width}`}
        top="0"
        height="100vh"
        width={viewerWidth ? width : "100vw"}
        animation={`${
          isOpen ? "slideIn" : "slideOut"
        } 0.8s ease-in-out forwards`}
      >
        <ModalHeader
          fontSize={{ base: "md", lg: "lg" }}
          color="teal.300"
          fontWeight="700"
          p=".6rem"
          ml="1rem"
        >
          Document
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody
          px={{ base: ".5rem", lg: "1.5rem" }}
          py=".2rem"
          overflowY="auto"
          className="customScrollBar"
          mb={{ base: "1rem", lg: "unset" }}
        >
          <Box
            display={{ base: "grid", lg: "flex" }}
            flexDirection={{ base: "column", lg: "row" }}
            gap={{ base: 1, lg: 6 }}
            h="100%"
          >
            {fetchFileLoader ? (
              <Box
                h={{ base: "30vh", md: "40vh", lg: "80vh" }}
                mb="1rem"
                w="100%"
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
              >
                <Spinner
                  size="xl"
                  thickness="4px"
                  speed="0.65s"
                  color="teal.400"
                />
              </Box>
            ) : (
              <Box
                h={{ base: "30vh", md: "40vh", lg: "85vh" }}
                w={{ lg: "45vw" }}
              >
                <FileViewer sample={sample} />
              </Box>
            )}

            {showValues && (
              <Box>
                <CustomInput
                  name="title"
                  label="Add Title"
                  value={title}
                  onChange={(e: any) => setTitle(e.target.value)}
                  isReadOnly={
                    statusType === "approved" ||
                    statusType === "rejected" ||
                    accountDetails.role === "admin"
                  }
                />
                <Box h="350px" mt={2}>
                  <RichTextEditor
                    editorHtml={editorHtml}
                    setEditorHtml={setEditorHtml}
                    isReadOnly={
                      statusType === "approved" ||
                      statusType === "rejected" ||
                      accountDetails.role === "admin"
                    }
                  />
                </Box>
              </Box>
            )}
          </Box>
        </ModalBody>
        {!isDisabled && ["approver", "uploader"].includes(accountDetails.role) && accountDetails.role !== "admin" && name === "Pending Approval" && (
          <ModalFooter p="0.5rem">
            {type === "create" ? (
              <Flex alignItems="center" gap={2} justifyContent="end">
                <Button
                  onClick={handleSaveWord}
                  bg="green.400"
                  color="white"
                  _hover={{ bg: "green.500" }}
                >
                  Submit
                </Button>
                <Button
                  onClick={() => {
                    setEditorHtml("");
                    setTitle("");
                  }}
                  colorScheme="red"
                >
                  Cancel
                </Button>
              </Flex>
            ) : (
              <>
                <Button
                  isDisabled={isloading}
                  onClick={() =>
                    setCommentModel({
                      open: true,
                      selectedStatus: "approved",
                      comment: "",
                      isMulti: false,
                    })
                  }
                  fontSize="sm"
                  bg="green.500"
                  color="white"
                  _hover={{ bg: "green.600" }}
                  mr="1rem"
                  w="100px"
                >
                  Accept
                </Button>
                <Button
                  isDisabled={isloading}
                  onClick={() =>
                    setCommentModel({
                      open: true,
                      selectedStatus: "rejected",
                      comment: "",
                      isMulti: false,
                    })
                  }
                  bg="red.500"
                  _hover={{ bg: "red.600" }}
                  color="white"
                  w="100px"
                  mr="14px"
                >
                  Reject
                </Button>
              </>
            )}
          </ModalFooter>
        )}
      </ModalContent>
      <style>
        {`
          @keyframes slideIn {
            from {
              right: -${width};
            }
            to {
              right: 0;
            }
          }
          @keyframes slideOut {
            from {
              right: 0;
            }
            to {
              right: -${width};
            }
          }
          `}
      </style>
      <CommentDrawer
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
        commentModel={commentModel}
        setCommentModel={setCommentModel}
        handleGet={handleGet}
        view={true}
        isOpen={commentModel.open}
        width={width}
        onClose={handleCloseCommentModal}
        handleClose={onClose}
        editedValues={{ title: title, content: editorHtml }}
        isWord={true}
        selectedFile={file}
      />
    </Modal>
  );
}
